import { NgModule } from '@angular/core';
import { HisAmountPipe } from 'hisng';
import { AmountUtils } from './utils/amount-utils';
import { FileSizeUtils } from './utils/filesize-utils';

/**
 * CoreModule for common components.
 */
@NgModule( {
    imports: [
    ],
    declarations: [
    ],
    exports: [
    ],
    providers: [
        HisAmountPipe,
        FileSizeUtils,
        AmountUtils,
    ],
} )

export class CommonCoreModule {
}
